import * as React from "react";

interface StatsPeriodProps {
    title: string;
    columns: any[];
    values: any[];
}

export const StatsPeriod = (props: StatsPeriodProps) => {
    return <div className="row users-stats-table-row mt-3 mb-3">
        <div className="col-2 text-center" title="Period from: 01.03.2020 To: 31.03.2020">
            <b>{ props.title }</b>
        </div>
        { props.columns.map((item, index) => {
            return <div key={index} className={`${item[1]} text-center`}>{props.values[index]}</div>
        }) }
    </div>
};
